import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Theme from 'components/common/Theme/Theme'
import Mixin from 'components/common/Mixin'
import Link from 'components/common/Link/Link'
import Media from 'components/common/Media'
import FollowLink from 'components/common/Link/FollowLink'
import { ServiceIcon } from 'components/common/ServiceIcon'
import { H2 } from 'components/common/Text/Text'


const ServiceTile = ({ className, categoryName, iconName, serviceCategorySeo, ...props }) =>
  <Wrapper className={ className } { ...props }>
    <ImageLink tabIndex="-1" to={ serviceCategorySeo }>
      <ServiceIcon data-at-services-servicetile-icon iconName={ iconName } condition large />
    </ImageLink>
    <H2 noMargin>
      <ServiceLink data-at-services-servicetile-name to={ serviceCategorySeo }>{ categoryName }</ServiceLink>
    </H2>
  </Wrapper>

ServiceTile.propTypes = {
  categoryName: PropTypes.string,
  className: PropTypes.string,
  iconName: PropTypes.string,
  serviceCategorySeo: PropTypes.string
}

export default ServiceTile

const Wrapper = styled.div`
  position: relative;
  display: inline-block;
  vertical-align: top;
  ${Mixin.responsive('margin', '12px', '8px')}
  ${Mixin.responsive('width', '228px', '136px')}
`

const ImageLink = styled(Link)`
  position: relative;
  display: block;
  background: ${Theme.colors.white};
  border: 1px solid ${Theme.colors.light_grey};
  ${Mixin.responsive('height', '228px', '136px')}
  ${Mixin.middle()}
`

const ServiceLink = styled(FollowLink)`
  span {
    display: inline-block;
    margin: 0 5px;
    ${Mixin.font.GothamBold(16)}
    ${Media.mobile`
      ${Mixin.font.GothamBold(15)}
      margin: 0;
    `}
  }
`
